export default {
  validate: value => new RegExp('^((\\+)[1-9]{1,2})[0-9\\s]{1,20}$').test(value),
  message: 'Numéro de téléphone incorrecte'
}
